
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WorkOrderBOMDialog extends _Ext.MFGTransBOMEditorDialog<WorkOrderBOMRow> {
        protected getFormKey() { return WorkOrderBOMForm.formKey; }
        protected getIdProperty() { return WorkOrderBOMRow.idProperty; }
        protected getLocalTextPrefix() { return WorkOrderBOMRow.localTextPrefix; }
        protected getNameProperty() { return WorkOrderBOMRow.nameProperty; }
        protected getService() { return WorkOrderBOMService.baseUrl; }
        protected getDeletePermission() { return WorkOrderBOMRow.deletePermission; }
        protected getInsertPermission() { return WorkOrderBOMRow.insertPermission; }
        protected getUpdatePermission() { return WorkOrderBOMRow.updatePermission; }

        IsConfigurable: boolean = false;
        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.PureWeight);



            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014)); 


            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.value = "";
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseBOMFields(this);
                }
            });


            this.form.CategoryId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                ItemFieldHelper.PurchaseBOMFields(this);
            })


            // Validate Purity
            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                if (KaratId != null) {
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                        this.form.Purity.value = std;
                    }
                }

            });

            this.form.KaratId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var std = purity.StdPurity;
                this.form.Purity.value = std;


            });

            this.form.ItemTypeId.changeSelect2(e => {
                ItemFieldHelper.PurchaseBOMFields(this);
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";

            });

            this.form.ShapeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";

            });

            this.form.SieveId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                var sievegroupid = OMS.AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                this.form.GroupSieveId.value = sievegroupid.toString();

            });

            this.form.QualityId.changeSelect2(e => {
                this.form.AttributeId.value = "0";

            });

            this.form.StoneColorId.changeSelect2(e => {
                this.form.AttributeId.value = "0";

            });
        }
        afterLoadEntity() {
            super.afterLoadEntity();

             

            let Component: OMS.RawMaterialMasterRow;
            if (!Q.isEmptyOrNull(this.form.BomProductId.value)) {
                OMS.RawMaterialMasterService.Retrieve({ EntityId: this.form.BomProductId.value }, response => Component = response.Entity, { async: false });
                this.IsConfigurable = Component.IsConfigurable;
            }
            var Dialog = this;
            switch (Dialog.form.ItemTypeId.value) {

                case 105: {
                    q.hideField(Dialog.form.KaratId);
                    q.hideField(Dialog.form.Purity);
                    q.hideField(Dialog.form.MetalColorId);
                    q.hideField(Dialog.form.Purity);
                    q.hideField(Dialog.form.PureWeight); 
                    q.showAndSetRequiredField(Dialog.form.Pieces);
                    q.showAndSetRequiredField(Dialog.form.SettingId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.ShapeId) : q.showAndDisableField(Dialog.form.ShapeId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.QualityId) : q.showAndDisableField(Dialog.form.QualityId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.StoneColorId) : q.showAndDisableField(Dialog.form.StoneColorId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.StoneSizeId) : q.showAndDisableField(Dialog.form.StoneSizeId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.SieveId) : q.showAndDisableField(Dialog.form.SieveId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.CategoryId) : q.showAndDisableField(Dialog.form.CategoryId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.SubCategoryId) : q.showAndDisableField(Dialog.form.SubCategoryId);

                    switch (parseInt(Dialog.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(Dialog.form.StoneCutId);
                            q.hideField(Dialog.form.StonePolishId);
                            q.hideField(Dialog.form.StoneSymmetryId);
                            q.hideField(Dialog.form.StoneFluorescenceId);
                            q.hideField(Dialog.form.StoneCuletId);
                            q.hideField(Dialog.form.StoneGirdleId);
                            q.hideField(Dialog.form.StoneTable);
                            q.hideField(Dialog.form.StoneDepth);
                            q.hideField(Dialog.form.CertificateNo); 
                            //q.hideEditorCategory(Dialog.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndSetRequiredField(Dialog.form.StoneCutId);
                            q.showAndSetRequiredField(Dialog.form.StonePolishId);
                            q.showAndSetRequiredField(Dialog.form.StoneSymmetryId);
                            q.showAndSetRequiredField(Dialog.form.StoneFluorescenceId);
                            q.showAndSetRequiredField(Dialog.form.StoneCuletId);
                            q.showAndSetRequiredField(Dialog.form.StoneGirdleId);
                            q.showAndSetRequiredField(Dialog.form.StoneTable);
                            q.showAndSetRequiredField(Dialog.form.StoneDepth);
                            q.showAndSetRequiredField(Dialog.form.CertificateNo);
                            q.showAndSetRequiredField(Dialog.form.Pieces);
                            q.showAndSetRequiredField(Dialog.form.Weight); 

                            break;
                        default:
                            q.hideField(Dialog.form.StoneCutId);
                            q.hideField(Dialog.form.StonePolishId);
                            q.hideField(Dialog.form.StoneSymmetryId);
                            q.hideField(Dialog.form.StoneFluorescenceId);
                            q.hideField(Dialog.form.StoneCuletId);
                            q.hideField(Dialog.form.StoneGirdleId);
                            q.hideField(Dialog.form.StoneTable);
                            q.hideField(Dialog.form.StoneDepth);
                            q.hideField(Dialog.form.CertificateNo);
                            break;
                    }

                    break;
                }
                case 104: {
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.KaratId) : q.showAndDisableField(Dialog.form.KaratId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.MetalColorId) : q.showAndDisableField(Dialog.form.KaratId);
                    Dialog.IsConfigurable == true ? q.showAndSetRequiredField(Dialog.form.Purity) : q.showAndDisableField(Dialog.form.KaratId);
                    q.showAndDisableField(Dialog.form.PureWeight); 

                    q.hideField(Dialog.form.ShapeId);
                    q.hideField(Dialog.form.QualityId);
                    q.hideField(Dialog.form.StoneColorId);
                    q.hideField(Dialog.form.StoneSizeId);
                    q.hideField(Dialog.form.SieveId);
                    q.hideField(Dialog.form.Pieces);
                    q.hideField(Dialog.form.CategoryId);
                    q.hideField(Dialog.form.SubCategoryId);
                    q.hideField(Dialog.form.CertificateNo);
                    q.hideField(Dialog.form.SettingId);
                    break;
                }

                default: {
                    q.hideField(Dialog.form.KaratId);
                    q.hideField(Dialog.form.Purity);
                    q.hideField(Dialog.form.MetalColorId);
                    q.hideField(Dialog.form.ShapeId);
                    q.hideField(Dialog.form.QualityId);
                    q.hideField(Dialog.form.StoneColorId);
                    q.hideField(Dialog.form.StoneSizeId);
                    q.hideField(Dialog.form.SieveId);
                    break;
                }
            }
            if (this.BOMMaster!=undefined&&this.BOMMaster.isReadOnly == true) {
                this.setReadOnly(true);
            }

        }

        protected validateBeforeSave() {
            this.entity.RefTransBomId === undefined ? this.entity.RefTransBomId = 0 : this.entity.RefTransBomId;
            return true;
        }
    }
}